import {sendApiMonitor} from '../../../utils/monitoring';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';

export const startMonitor = params => {
    const startDate = new Date();

    const session = params?.Session;
    const appTime = 0;
    const dbTime = 0;
    const networkTime = 0;
    const formName = params?.Fname || formsStore?.currentForm?.name;

    return {
        session,
        appTime,
        dbTime,
        networkTime,
        formName,
        startDate
    };
};

export const sendMonitor = (methodName, monitor, response, transactionResult) => {
    let {session, appTime, dbTime, networkTime, formName, startDate} = monitor;

    const endDate = new Date();
    const totalTime = (endDate.getTime() - startDate.getTime()) / 1000;
    const Perf = response?.Perf;

    session = session || response.Session;
    appTime = Math.round(Perf?.AppTime * 100) / 100 || 0;
    dbTime = Math.round(Perf?.DBTime * 100) / 100 || 0;
    networkTime = totalTime - appTime - dbTime;

    sendApiMonitor(
        methodName,
        formName,
        session,
        transactionResult,
        '',
        dbTime,
        appTime,
        networkTime
    );
};
